"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveConfigSection = exports.getConfig = void 0;
const storage_1 = require("./storage");
const objects_1 = require("./objects");
const utilitiesConfig = new storage_1.InBrowserStorage('@built/mfe-utilities::config', {}, {
    provider: 'localStorage',
}); // we use any for backwards compat
/**
 * Get shared MFE utilities core config saved in local storage.
 *
 * **NOTE**: Apps should use `InBrowserStorage` to handle their own config/settings.
 *
 * If LS is not available or value is missing or cannot be parsed as JSON, default config will be returned.
 **/
const getConfig = (defaultConfiguration = {}) => {
    const result = utilitiesConfig.get();
    return Object.keys(result).length > 0 ? result : (0, objects_1.deepClone)(defaultConfiguration); // for backwards compat, in case other value supplied for default
};
exports.getConfig = getConfig;
/**
 * Saves given config section into the local storage for the MFE utilities config.
 *
 * **NOTE**: Apps should use `InBrowserStorage` to handle their own config/settings.
 *
 * @param configSection - name of configuration part (property name on root config object)
 * @param sectionConfig - value to save for the configuration part--must be JSON-serializable
 * @returns
 */
const saveConfigSection = (configSection, sectionConfig) => {
    utilitiesConfig.saveSection(configSection, sectionConfig);
};
exports.saveConfigSection = saveConfigSection;
